<template>
  <div class="personal-conatiner">
      <div class="popup__close" @click="close" >
          <svg-icon :name="'close'" :width="32" :height="32"></svg-icon>
      </div>
  <div class="personal-text">
      <!-- eslint-disable max-len -->
      <h2>
        СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
      </h2>
      Настоящим я, действуя от своего имени, добровольно и не находясь под влиянием заблуждения, проставляя галочку напротив текста «Я даю согласие на обработку персональных данных», и нажимая на кнопку отправки заполненной формы, <b>даю свое согласие следующему оператору персональных данных:</b>
          <br><br>ИП Земсков Алексей Васильевич (ОГРНИП: 325774600090650, ИНН 371400551536) (далее — «Оператор»); 
          <br><br>на смешанную обработку, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, блокирование, удаление, уничтожение следующих персональных данных:
          <br><br>
          <table>
            <tr>
              <td></td>
              <td><b>Общие категории персональных данных</b></td>
            </tr>
            <tr>
              <td>1.1.</td>
              <td>фамилия, имя, отчество;</td>
            </tr>
            <tr>
              <td>1.2.</td>
              <td>адрес электронной почты;</td>
            </tr>
            <tr>
              <td>1.3.</td>
              <td>контактный телефон;</td>
            </tr>
            <tr>
              <td>1.4.</td>
              <td>сведения о предпочтительном способе связи;</td>
            </tr>
            <tr>
              <td>1.5.</td>
              <td>имя пользователя в мессенджере и (или) сведения о других способах связи, представленных мной в рамках взаимодействия с оператором персональных данных;</td>
            </tr>
            <tr>
              <td>1.6.</td>
              <td>адрес (адрес доставки, производства работ);</td>
            </tr>
            <tr>
              <td>1.7.</td>
              <td>сведения в поле «Комментарий»;</td>
            </tr>
            <tr>
              <td>1.8.</td>
              <td>файлы cookies и данные, собираемые на сайте посредством агрегаторов статистики посетителей веб-сайтов., в том числе «Яндекс Метрика»</td>
            </tr>
          </table>
          <br>
          <p>
            в целях обработки входящих заявок с Сайта размещенного по адресу: <a class="zemsdesgin-link" href=" https://zemsdesign.ru/baza/" target="_blank">https://zemsdesign.ru/baza/</a> в целях подготовки, заключения и исполнения гражданско-правовых договоров, а также в целях продвижения товаров, работ и услуг,
          </p>
          <br>
          <p>
            я понимаю и принимаю, что заявка представляет собой намерение получить предложение, владельцем которого является третье лицо — партнер Оператора и в целях его получения мне необходимо заключить договор с таким третьим лицом, в связи с этим, 
          </p>
          <br>
          <p>
            я также даю согласие на передачу (предоставление, доступ) указанных выше категорий персональных данных третьим лицам, привлекаемым Оператором для обработки моей заявки и ее реализации, в том числе посредством подготовки, заключения и исполнения гражданско-правовых договоров между мной и третьими лицами и выполнения обязательств по ним, включая лиц, непосредственно участвующих в выполнении работ, оказании услуг, поставке товаров, которые являются предметом моей заявки, согласовании условий исполнения обязательств, организации доставки и логистики, приёме и обработке платежей, оформлении расчётов и фискальных документов, а также иных лиц, обеспечивающих организационное, информационное и техническое сопровождение указанных процессов, а также третьим лицам, оказывающим услуги, выполняющим работы и/или поставляющим товары, сведения (предложения) о которых и (или) товарах, работах и (или) услугах которых были доведены Оператором до моего сведения в ходе рассмотрения моего обращения (заявки) и/или исполнения договоров и в отношении которых и (или) в отношении товаров, работ и (или) услуг которых я любым способом выразил(а) желание получить предложение, заключить договор, приобрести товар, работу и (или) услугу и (или) поручил(а) Оператору передать мои персональные данные — в объёме, необходимом для достижения указанных в настоящем согласии целей.
          </p>
          <br>
          <p>
            Срок действия настоящего согласия на обработку персональных данных начинается с момента его представления Оператору и прекращается по достижении целей обработки персональных данных, по получении отзыва согласия на обработку персональных данных или исключения Оператора из Единого государственного реестра юридических лиц.
          </p>
          <br>
          <p>
            Настоящее согласие может быть отозвано путем обращения к Оператору с соответствующим запросом по электронной почте director@zemsbaza.ru. В этом случае Оператор прекращает обработку персональных данных, а персональные данные подлежат уничтожению, если отсутствуют иные правовые основания для обработки, установленные законодательством Российской Федерации.
          </p>
  </div>
</div>

</template>

<script>
export default {
    name: 'personalPolicy',
    components: {
    },
    props: {
    },
    data() {
        return {
          previousRoute: false,
        };
    },
    mounted() {
      window.scrollTo(0, 0);

      this.previousRoute = this.$router.options?.history?.state?.back
    },
    computed: {

    },
    watch: {

    },
    methods: {
        close() {
          if (this.previousRoute) {
            this.$router.back()
          } else {
            this.$router.push('/')
          }
        },
    },
};
</script>

<style lang="sass" scoped>
.personal-conatiner
  width: 896px
  margin: 0 auto
  padding-top: 88px
  padding-bottom: 184px
  +for-mobile
      width: 296px
      padding-top: 48px
      padding-bottom: 120px

  .popup__close
      position: fixed
      top: 32px
      right: 32px
      +for-mobile
          top: 8px
          right: 8px

  .personal-text
      font-style: normal
      font-weight: 400
      font-size: 20px
      line-height: 24px
      color: #606060
      .zemsdesgin-link
        white-space: nowrap
      a
        color: #2F80ED
      table
        border-collapse: separate
        border-spacing: 0
        width: 100%
        border: 1px solid #D8D8D8
        border-radius: 12px
        overflow: hidden
        margin-top: 6px
        margin-bottom: 6px
        +for-mobile
          margin-top: -10px
          margin-bottom: -5px
      td
        padding: 14.5px 11px
        border: 1px solid #D8D8D8
        &:first-child
          text-align: center
        +for-mobile
          height: 42px
          padding: 0
          padding-left: 7px
      tr
        td
          &:last-child
            padding-left: 14px
            +for-mobile
              padding: 11px 7px
        &:first-child td
          &:first-child
            padding: 0 11px
            text-align: center
            border-top-left-radius: 12px
            +for-mobile
              height: 60px
              padding: 0 7px
          &:last-child
            border-top-right-radius: 12px
        &:last-child td
          &:first-child
            border-bottom-left-radius: 12px
            padding:  24px 11px
            +for-mobile
              padding: 0 7px
          &:last-child
            border-bottom-right-radius: 12px

      +for-mobile
          font-size: 16px
          line-height: 18px

      h2
          font-family: "Oswald", sans-serif
          font-style: normal
          font-weight: 500
          font-size: 38px
          line-height: 140%
          color: #0F0F0F
          margin-bottom: 32px
          +for-mobile
              font-size: 26px
              line-height: 120%
              margin-bottom: 15px

      h4
          text-transform: uppercase
          font-weight: 700
      b
          font-weight: 700

      ul
          padding-left: 1rem
          li
              list-style-type: disc
              list-style-position: outside
</style>
